import React from "react"

const Name = cell => {
  return cell.value ? cell.value : "-"
}

const ShortDescription = cell => {
  return cell.value ? (
    <div>
      {cell.value.length > 50
        ? cell.value.substring(0, 50) + "..."
        : cell.value}
    </div>
  ) : (
    "---"
  )
}

export { Name, ShortDescription }
